<template>
  <div>
    <el-container>

      <el-main>
        <el-row>
          <el-col v-if="!hideBreadcrumb"
                  :span="22"
                  :offset="1">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }"><i class="iconfont">&#xe60b;</i>&nbsp;返回首页</el-breadcrumb-item>
              <el-breadcrumb-item>
                服务支持
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <br />
          <br />
          <el-col :span="22"
                  :offset="1"
                  class="whiteContainer">
            <el-row>
              <el-col :span="6"
                      class="service_out_container">
                <div class="service_container">
                  <img src="../assets/imgs/service_1.png"
                       alt="" />
                  <div class="service_title">1.系统定制</div>
                  <div class="service_desc">个性化定制智能研报系统，提供数据获取、报告自动生成等服务</div>
                </div>
              </el-col>
              <el-col :span="6"
                      class="service_out_container">
                <div class="service_container">
                  <img src="../assets/imgs/service_1.png"
                       alt="" />
                  <div class="service_title">2.报告定制</div>
                  <div class="service_desc">对报告类型、报告内容、自动化快讯等进行深度定制</div>
                </div>
              </el-col>
              <el-col :span="6"
                      class="service_out_container">
                <div class="service_container">
                  <img src="../assets/imgs/service_1.png"
                       alt="" />
                  <div class="service_title">3.API对接</div>
                  <div class="service_desc">
                    按需制定接口，输出智能报告
                  </div>
                </div>
              </el-col>
              <el-col :span="6"
                      class="service_out_container">
                <div class="service_container">
                  <img src="../assets/imgs/service_1.png" />
                  <div class="service_title">4.高级功能</div>
                  <div class="service_desc">模板管理等高级功能试用</div>
                </div>
              </el-col>
            </el-row>

            <br />
            <el-row>
              <h3 style="text-align: center;">定制化服务需求</h3>
            </el-row>
            <el-row class="service_out_container">
              <el-row style="background-color:#F1F4F7">
                <el-col :span="9"
                        :offset="6">
                  <br />
                  <br />
                  <el-form ref="form"
                           :rules="rules"
                           :model="form"
                           label-width="100px">
                    <el-form-item label="需求类型"
                                  :required="true">
                      <el-radio-group v-model="form.type">
                        <el-radio label="PERSON">&nbsp;&nbsp;&nbsp;&nbsp;个人需求</el-radio>
                        <el-radio label="COMPANY">&nbsp;&nbsp;&nbsp;&nbsp;单位需求</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item label="省份"
                                  prop="address">
                    <el-select v-model="form.address" class="m-2" placeholder="选择省份" size="large">
    <el-option
      v-for="item in addressJson"
      :key="item.code"
      :label="item.name"
      :value="item.name"
    />
  </el-select>
  </el-form-item>
                    <el-form-item label="姓名"
                                  prop="name">
                      <el-input v-model="form.name"
                                placeholder="请输入您的真实姓名"></el-input>
                    </el-form-item>

                    <template v-if="form.type === 'COMPANY'">
                      <el-form-item label="公司"
                                    prop="company">
                        <el-input v-model="form.company"
                                  placeholder="请输入您所在的公司"></el-input>
                      </el-form-item>
                    </template>
                    <el-form-item label="手机号"
                                  prop="mobile">
                      <el-input v-model.number="form.mobile"
                                :maxlength="15"
                                placeholder="请输入您的手机号"></el-input>
                    </el-form-item>

                    <el-form-item label="邮箱"
                                  prop="email">
                      <el-input v-model="form.email"
                                placeholder="请输入您的邮箱"></el-input>
                    </el-form-item>

                    <el-form-item label="需求">
                      <el-input type="textarea"
                                placeholder="请填写具体需求，以便我们更好地为您服务"
                                v-model="form.advice"></el-input>
                    </el-form-item>

                    <el-form-item>
                      <el-button type="primary"
                                 @click="toSubForm">&nbsp;&nbsp;&nbsp;&nbsp;提&nbsp;&nbsp;交&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </el-row>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

  </div>
</template>

<script>
import addressJson from '../assets/json/address'
import Dropzone from 'vue2-dropzone'
import axios from 'axios'
import myNav from '../components/nav'
import myMenu from '../components/menu'
export default {
  props: ['hideBreadcrumb'],
  name: 'myReports',
  data: function () {
    let checkMobile = (rule, value, callback) => {
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!myreg.test(value)) {
        callback(new Error('请输入正确的11位手机号'))
        return
      }
      callback()
    }
    let checkEmail = (rule, value, callback) => {
      let myreg = /^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!myreg.test(value) || value.trim().length > 30) {
        callback(new Error('请输入正确的邮箱'))
        return
      }
      callback()
    }
    let checkCompany = (rule, value, callback) => {
      if (!value) {
        callback(new Error('公司名称不能为空'))
        return
      }
      if (value.length < 3 || value.length > 20) {
        callback(new Error('请输入正确的公司名'))
        return
      }
      callback()
    }

    return {
      addressJson: addressJson,
      form: {
        type: 'PERSON',
        name: '',
        comparny: '',
        mobile: '',
        email: '',
        advice: '',
        address: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入您的真实姓名', trigger: 'blur' },
          {
            min: 2,
            max: 5,
            message: '长度在 2 到 5 个字符',
            trigger: 'blur'
          }
        ],
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            validator: checkMobile,
            message: '请输入正确的11位手机号',
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          {
            validator: checkEmail,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        company: [
          { required: true, message: '公司名不能为空', trigger: 'blur' },
          { validator: checkCompany, trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  methods: {
    toSubForm () {
      let _this = this
      this.$refs['form'].validate(valid => {
        if (valid) {
          axios.post('/api/web/advice/add', _this.form).then(resp => {
            _this.$message({
              message: '您的需求已经提交，谢谢!',
              type: 'success'
            })
            let type = _this.form.type
            _this.form = {}
            _this.form.type = type
            if (_this.form.type === 'PERSON') {
            }
          })
        } else {
          return false
        }
      })
    }
  },
  components: {
    myNav,
    myMenu,
    Dropzone
  },
  mounted () {
    let _this = this
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = 'http://pv.sohu.com/cityjson?ie=utf-8'
    s.onload = (resp) => {
      // eslint-disable-next-line no-undef
      let temp = returnCitySN
      if (temp) {
        _this.form.address = temp.cname
      }
    }
    document.body.appendChild(s)
  }
}
</script>
<style lang="less" scoped>
.service_container {
  width: 100%;
  margin: auto;
  text-align: center;
  border: 1px solid #e5e5e5;
  height: 190px;
  padding-top: 25px;
  .service_title {
    text-align: center;
    padding-top: 10px;
    font-size: 0.9em;
  }
  .service_desc {
    text-align: center;
    color: #999999;
    padding-top: 10px;
    font-size: 0.8em;
  }
}
.service_out_container {
  padding: 25px 20px;
  box-sizing: border-box;
}
   /deep/   .el-input__inner {
        font-family: monospace !important;
      }
</style>



// WEBPACK FOOTER //
// src/app/service.vue